import { render, staticRenderFns } from "./SuiteOwnerModal.vue?vue&type=template&id=22d8a412&scoped=true"
import script from "./SuiteOwnerModal.vue?vue&type=script&lang=ts"
export * from "./SuiteOwnerModal.vue?vue&type=script&lang=ts"
import style0 from "./SuiteOwnerModal.vue?vue&type=style&index=0&id=22d8a412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8a412",
  null
  
)

export default component.exports